<template>
    <section class="recover-pswd-comp">
        <SwipeModalComponent v-if="recoverPasswordMenu.isVisible" @closeMenu="changeRecoverPasswordMenuVisibility">
            <div class="content-wrapper">
                <div class="stripe"></div>
                <h2> Recuperar Senha </h2>

                <div v-if="!verifyingCode">
                    <div class="menu-itens-container" v-for="(element, elkey) in formData" :key="elkey">
                        <label :for="getId(element.display)" v-text="element.display"></label>
                        <input :name="getId(element.display)" :id="getId(element.display)" :type="element.type" :placeholder="element.placeHolder" v-model.trim="txtLogin"/>
                    </div>
                    <div class="footer-itens-container" v-if="!loading">
                        <div v-for="(btn, btnkey) in buttons" :key="btnkey">
                            <button :id="getId(btn.display)" v-text="btn.display" @click="handleClick(btn)"></button>
                        </div>
                    </div>
                    <div  class="footer-itens-container" v-else>
                        <h1>
                            Verificando dados
                            <i class="fas fa-spinner fa-spin"></i>
                        </h1>
                    </div>
                </div>
                <div v-else>
                    <div class="menu-itens-container">
                        <label for="code">Digite aqui o código de verificação enviado para o email cadastrado:</label>
                        <input name="code" :id="getId('Código de verificação')" :type="'text'" :placeholder="'Código de verificação'" v-model="typedCode"/>
                    </div>
                    <div class="footer-itens-container">
                        <button @click="checkCode">Confirmar</button>
                    </div>
                </div>
            </div>
        </SwipeModalComponent>
        <ModalInfo></ModalInfo>
        <LoginStoreOptionsModal v-if="showStoreOptionsModal" @closeModal="closeStoreOptionsModal()"></LoginStoreOptionsModal>
    </section>
</template>
<script>
import ModalInfo from '@/components/modals/ModalInfo.vue'
import LoginStoreOptionsModal from '@/components/modals/LoginStoreOptionsModal.vue'
import SwipeModalComponent from './SwipeModalComponent.vue'
import { showAlertNotification, showSuccessNotification, showErrorNotification } from '@/libs/Util'
import { forgotPassword } from '@/components/controllers/LoginController.js'
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'RecoverPasswordMenu',
    components: {
        ModalInfo,
        SwipeModalComponent,
        LoginStoreOptionsModal
    },
    data () {
        return {
            txtLogin: '',
            formData: [
                {
                    placeHolder: 'Login',
                    display: 'Informe seu login (CPF, Matrícula, Nome de usuário)',
                    required: true,
                    type: 'text'
                }
            ],
            buttons: [
                {
                    icon: '',
                    display: 'Confirmar',
                    action: 'recoverPassword'
                }
            ],
            selectedInstitution: '',
            recoverCDCONSUMIDOR: '',
            loading: false,
            verifyingCode: false,
            correctCode: '',
            typedCode: '',
            recoverUserName: '',
            showStoreOptionsModal: false
        }
    },
    computed: {
        ...mapGetters(['recoverPasswordMenu', 'getSelectedLoginOption'])
    },
    methods: {
        ...mapActions(['changeRecoverPasswordMenuVisibility', 'setRecoverPasswordData',
            'showModalInfo', 'setLoginStoreOptions']),

        getId: function (display) {
            return display.replaceAll(' ', '').toLowerCase()
        },
        handleClick: function (btn) {
            if (btn.action) {
                this[btn.action]()
            }
        },
        closeStoreOptionsModal: function () {
            this.showStoreOptionsModal = false

            if (this.getSelectedLoginOption?.CDCLIENTE) {
                this.selectedInstitution = this.getSelectedLoginOption.CDCLIENTE
                this.recoverPassword()
            }
        },
        recoverPassword: function () {
            const login = this.txtLogin.trim()
            if (!login) {
                showAlertNotification({
                    title: '',
                    text: 'Informe o login para recuperar a senha.'
                })
                return
            }

            this.loading = true
            forgotPassword(login, this.selectedInstitution || null).then((res) => {
                this.loading = false
                if (!res || res.error || res.sucesso === false) {
                    const errorText = res?.message || res?.data || 'Não foi possível recuperar a senha.'
                    showErrorNotification({
                        title: '',
                        text: errorText
                    })

                    return
                }
                if (res.emailSent) {
                    const defaultMsg = 'O código de recuperação foi enviado para ' + res.email
                    const messageText = res.customMsg ? res.customMsg : defaultMsg
                    showSuccessNotification({
                        title: '',
                        text: messageText,
                        duration: 5000
                    })
                    this.verifyingCode = true
                    this.correctCode = res.checkingCode
                    this.recoverUserName = res.userName

                    if (res.CDCLIENTE) {
                        this.selectedInstitution = res.CDCLIENTE
                    }
                    if (res.CDCONSUMIDOR) {
                        this.recoverCDCONSUMIDOR = res.CDCONSUMIDOR
                    }
                } else if (res.showSelectPopup) {
                    this.setLoginStoreOptions(res.options)
                    this.showStoreOptionsModal = true
                } else {
                    showErrorNotification({
                        title: '',
                        text: 'Não foi possível enviar o código de recuperação para ' + res.email
                    })
                }
            })
        },
        checkCode: function () {
            if (this.typedCode.trim() === this.correctCode) {
                this.setRecoverPasswordData({
                    CDCLIENTE: this.selectedInstitution,
                    CDCONSUMIDOR: this.recoverCDCONSUMIDOR,
                    NMLOGINCONS: this.txtLogin.trim(),
                    userName: this.recoverUserName
                })
                this.changeRecoverPasswordMenuVisibility()
                this.$router.push('recoverpassword')
            } else {
                showErrorNotification({
                    title: '',
                    text: 'Código de verificação incorreto.'
                })
            }
        }
    }
}
</script>
<style lang="less" scoped>
.content-wrapper {
    max-width: 100%;

    h2 {
        text-align: center;
        &:last-of-type {
            margin-bottom: 30px;
        }
    }
    .select-container {
        padding: 5px;
        .select {
            padding: 5px;
            width: 100%;
            height: 30px;
            border: solid #BAB8B8 2px;
            border-radius: 5px;
            padding: 0 10px;
            font-size: 18px;
            font-family: Gellix;
            margin: 15px auto;
            &:focus {
                outline: none;
            }

            option {
                font-size: 14px;
            }
        }

    }

    .menu-itens-container {
        padding: 5px;
        margin-top: 15px;
        overflow: auto;
        label {
            display: block;
            position: relative;
            margin-bottom: 15px;
        }
        input:not([type="checkbox"]) {
            width: calc(100% - 20px);
            border-radius: 7px;
            padding: 15px 10px;
            // background: #E2E2E2;
            border: 1px solid #00000033;
            font-size: 18px;
        }

    }
    .footer-itens-container {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        h1 {
            color: var(--primaryColor);
            font-size: 18px;
            font-weight: 600;
            margin: 25px 15px 30px 15px;
        }
        button {
            text-align: right;
            border-radius: 5px;
            color: var(--buttonText);
            padding: 10px;
            margin: 10px 5px 20px;
            font-weight: 600;
            border: none;
            background-color: var(--buttonBackground);
        }
    }
}
</style>
